import TextInput from '@adsk/bim360-matrix-react-components/es/components/TextInput';
import Button from '@hig/button';
import '@hig/button/build/index.css';
import TextArea from '@hig/text-area';
import '@hig/text-area/build/index.css';
import { t, Trans } from '@lingui/macro';
import { I18n } from '@lingui/react';
import log from 'loglevel';
import React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import * as api from '../../apis/api';
import {
  getCountry,
  getLanguage,
  totalMinutes,
  waitTimeTimeout
} from '../../app.config';
import {
  checkForErrors,
  getEstimatedWaitTime
} from '../../utils/waitTimeHelpers';
import ErrorBoundary from '../ErrorBoundary';
import { AlertExplanation } from './../Icons/SVGIcons';
import './UserInfoForm.styles';
import * as Styles from './UserInfoForm.styles.js';

/**
 * UserInfoForm
 */
class UserInfoForm extends React.PureComponent {
  _isMounted = false;

  constructor(props) {
    super(props);
    const firstName = this.props.variables.firstName
      ? this.props.variables.firstName
      : '';
    const lastName = this.props.variables.lastName
      ? this.props.variables.lastName
      : '';
    const email = this.props.variables.email ? this.props.variables.email : '';
    const phone = this.props.variables.phone ? this.props.variables.phone : '';
    const issue = this.props.variables.issue ? this.props.variables.issue : '';
    const language = this.props.variables.language
      ? this.props.variables.language
      : 'en_US';
    const userSessionId = this.props.variables.userSessionId
      ? this.props.variables.userSessionId
      : window.location.href;
    const intent = this.setIntent(this.props.variables.intent);
    const product = this.props.variables.product
      ? this.props.variables.product
      : '';
    const skillId = this.props.variables.skillId
      ? this.props.variables.skillId
      : '';
    const requestId = this.props.variables.requestId
      ? this.props.variables.requestId
      : '';

    this.state = {
      firstName: firstName,
      lastName: lastName,
      fullName: firstName + ' ' + lastName,
      email: email,
      phone: phone,
      issue: issue,
      language: language,
      userSessionId: userSessionId,
      supportLanguage: getLanguage(language),
      country: getCountry(language),
      product: product,
      skillId: skillId,
      requestId: requestId,
      phoneValid: true,
      emailError: false,
      phoneError: false,
      buttonDisabled: this.props.variables.buttonDisabled,
      invalidPhoneClass: '',
      invalidEmailClass: '',
      setSubmitted: this.props.setSubmitted,
      closeModal: this.props.closeModal,
      showUnavailable: false,
      showNoAgent: false,
      inactivePage: false,
      textAreaCount: 0,
      waitTime: -1,
      waitTimeNotes: '',
      intent: intent
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    const params = {
      supportLanguage: this.state.supportLanguage,
      intent: this.state.intent,
      customerTier: this.getCustomerTier(),
      country: this.state.country,
      userSessionId: this.state.userSessionId
    };

    if (this.state.product !== '') {
      params['product'] = this.state.product;
    }

    if (this.state.skillId === '' || this.state.requestId === '') {
      api
        .getConnectionOptions(params)
        .then((result) => {
          log.debug('api.getConnectionOptions', result);

          if (
            Object.keys(result.data).length &&
            result.data.StatusCode !== 404
          ) {
            log.debug('skillId', result.data[0].ModalityAttributes[0].SkillId);
            log.debug('requestId', result.data[0].ConnectionOptionRequestId);
            log.debug(
              'estimatedWaitTime',
              result.data[0].ModalityAttributes[0].EstimatedWaitTime
            );
            log.debug(
              'estimatedWaitTimeNotes',
              result.data[0].ModalityAttributes[0].EstimatedWaitTimeNotes
            );

            const data = {
              // contactId: '',
              skillId: result.data[0].ModalityAttributes[0].SkillId,
              requestId: result.data[0].ConnectionOptionRequestId
            };

            let estWaitTime =
              result.data[0].ModalityAttributes[0].EstimatedWaitTime;
            if (result.data[0].ModalityAttributes[0].EstimatedWaitTime < 2) {
              estWaitTime = 2;
            }

            this.setState(
              {
                skillId: result.data[0].ModalityAttributes[0].SkillId,
                requestId: result.data[0].ConnectionOptionRequestId,
                waitTime: estWaitTime,
                waitTimeNotes:
                  result.data[0].ModalityAttributes[0].EstimatedWaitTimeNotes
              },
              () =>
                checkForErrors(
                  result.data[0].ModalityAttributes[0].StatusCode,
                  this,
                  true
                )
            );

            this.interval = setInterval(
              () => getEstimatedWaitTime(data, this, true),
              waitTimeTimeout
            );
            setTimeout(() => {
              clearInterval(this.interval);
            }, totalMinutes);
          } else {
            log.debug(
              'Setting 404 as body is empty or result.data.StatusCode is 404'
            );
            checkForErrors(404, this, true);
          }
        })
        .catch((error) => {
          log.error('api.getConnectionOptions', error);
          this.setState({
            inactivePage: true,
            showUnavailable: true,
            buttonDisabled: true
          });
        });
    } else {
      const data = {
        // contactId: '',
        skillId: this.state.skillId,
        requestId: this.state.requestId
      };
      getEstimatedWaitTime(data, this, true);
      this.interval = setInterval(
        () => getEstimatedWaitTime(data, this, true),
        waitTimeTimeout
      );
      setTimeout(() => {
        clearInterval(this.interval);
      }, totalMinutes);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    log.debug('Interval', this.interval);
    if (typeof this.interval !== 'undefined') {
      clearInterval(this.interval);
    }
  }

  validateForm = () => {
    const disabled =
      this.state.firstName === '' ||
      this.state.lastName === '' ||
      this.state.email === '' ||
      this.state.emailError ||
      this.state.phone === '' ||
      this.state.phoneError ||
      this.state.issue === '';
    this.setState({
      buttonDisabled: disabled
    });
  };

  onSubmit = () => {
    this.validateForm();
    document.querySelector('.button-spinner').style.display = '';

    this.setState(
      {
        buttonDisabled: true
      },
      () =>
        (document.querySelector(
          '.hig__button-v1.hig__button-v1--disabled'
        ).style.opacity = '0.5')
    );

    const data = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      fullName: this.state.fullName,
      email: this.state.email,
      phone: this.state.phone,
      issue: this.state.issue,
      buttonDisabled: this.state.buttonDisabled,
      skillId: this.state.skillId,
      requestId: this.state.requestId,
      userSessionId: this.state.userSessionId
    };

    this.props.setSubmitted(data);
  };

  /**
   * Unsure how we will set this.
   * For now, it's hard-coded.
   * If a uses has an account - it would be set to ??
   */
  getCustomerTier = () => {
    return 'UnAuthenticated';
  };

  /**
   * Handle case issues with intent being passed in.
   * Set up mapping for future intent for other contact types.
   */
  setIntent = () => {
    let intent = this.props.variables.intent;
    /**
     * Per UHM-1348 - we are not validating consent.
     * Code left here if we need to implement validation based
     * on a well-defined set of intents.
     */
    // if (typeof this.props.variables.intent !== 'undefined') {
    //   log.debug(
    //     'intent input toLowerCase',
    //     this.props.variables.intent.toLowerCase()
    //   );
    //   switch (this.props.variables.intent.toLowerCase()) {
    //     case 'presales': {
    //       intent = 'Presales';
    //       break;
    //     }
    //     default: {
    //       intent = 'Presales';
    //     }
    //   }
    // }
    log.debug('intent for api', intent);
    return intent;
  };

  setFullName = () => {
    this.setState(
      { fullName: this.state.firstName + ' ' + this.state.lastName },
      () => {
        this.validateForm();
      }
    );
  };

  emailValidator = () => {
    let email = this.state.email;
    if (typeof email !== 'undefined' && email !== '') {
      const validator = require('email-validator');
      if (!validator.validate(email)) {
        this.setState(
          {
            emailError: true,
            invalidEmailClass: 'invalid-email'
          },
          () => {
            this.validateForm();
          }
        );
      } else {
        this.setState(
          {
            emailError: false,
            invalidEmailClass: ''
          },
          () => {
            this.validateForm();
          }
        );
      }
    }
  };

  phoneValidator = () => {
    if (this.state.phone !== '') {
      let phoneValid = this.state.phoneValid;
      /**
       * match regex to check if the phone number is valid
       * with hyphens and different country standards
       */
      phoneValid = this.state.phone.match(/^(\(?\+?[ ()0-9-]*^.{8,}\d{4,10}$)/);
      if (phoneValid) {
        this.setState(
          {
            phoneError: false,
            invalidPhoneClass: ''
          },
          () => {
            this.validateForm();
          }
        );
      } else {
        this.setState(
          {
            phoneError: true,
            invalidPhoneClass: 'invalid-phone'
          },
          () => {
            this.validateForm();
          }
        );
      }
    }
  };

  onChange({ target }) {
    if (
      typeof target !== 'undefined' &&
      typeof target.value !== 'undefined' &&
      target.value.length > 512
    ) {
      target.value = target.value.substring(0, 512);
    }
    this.setState(
      {
        [target.name]: target.value,
        textAreaCount: target.value.length
      },
      () => {
        this.validateForm();
      }
    );
  }

  render() {
    return (
      <ErrorBoundary>
        <Styles.StyledWrapper>
          <form>
            <Styles.StyledForm>
              <Styles.StyledH1>
                <Trans>Request a call</Trans>
              </Styles.StyledH1>
              <Styles.StyledErrorNotice>
                <div
                  id="unavailable"
                  style={{
                    display: this.state.showUnavailable ? 'block' : 'none'
                  }}
                >
                  <I18n>
                    {({ i18n }) =>
                      i18n._(
                        t`Service is unavailable at the moment. Please try again later.`
                      )
                    }
                  </I18n>
                </div>
                <div
                  id="no-agent"
                  style={{ display: this.state.showNoAgent ? 'block' : 'none' }}
                >
                  <I18n>
                    {({ i18n }) =>
                      i18n._(
                        t`No agents are available at the moment. Please try again later.`
                      )
                    }
                  </I18n>
                </div>
              </Styles.StyledErrorNotice>
              <Styles.StyledStandardText
                className={this.state.inactivePage ? 'inactive-page' : ''}
                style={{ display: this.state.inactivePage ? 'none' : 'block' }}
              >
                <div
                  className="text-spinner"
                  style={{
                    display: this.state.waitTime === -1 ? 'block' : 'none'
                  }}
                />
                <div
                  style={{
                    display: this.state.waitTime === -1 ? 'none' : 'block'
                  }}
                >
                  <Trans>
                    Estimated wait time: about {this.state.waitTime} minutes
                  </Trans>
                </div>
              </Styles.StyledStandardText>
              <Styles.StyledFlexRow
                className={this.state.inactivePage ? 'inactive-page' : ''}
              >
                <Styles.StyledFlexColumn>
                  <Styles.StyledFieldLabel htmlFor="first-name">
                    <Trans>First name</Trans>
                  </Styles.StyledFieldLabel>
                  <Styles.StyledFieldInput className="input-field">
                    <TextInput
                      id="first-name"
                      name="firstName"
                      onChange={(firstName) =>
                        this.setState({ firstName }, function() {
                          this.setFullName();
                        })
                      }
                      value={this.state.firstName}
                      placeholder=""
                      inputUIType="NORMAL"
                      disabled={this.state.inactivePage}
                    />
                  </Styles.StyledFieldInput>
                </Styles.StyledFlexColumn>
                <Styles.StyledFlexColumn>
                  <Styles.StyledFieldLabel htmlFor="last-name">
                    <Trans>Last name</Trans>
                  </Styles.StyledFieldLabel>
                  <Styles.StyledFieldInput className="input-field">
                    <TextInput
                      name="lastName"
                      onChange={(lastName) =>
                        this.setState({ lastName }, function() {
                          this.setFullName();
                        })
                      }
                      value={this.state.lastName}
                      placeholder=""
                      inputUIType="NORMAL"
                      disabled={this.state.inactivePage}
                    />
                  </Styles.StyledFieldInput>
                </Styles.StyledFlexColumn>
              </Styles.StyledFlexRow>
              <Styles.StyledFlexRow
                className={this.state.inactivePage ? 'inactive-page' : ''}
              >
                <Styles.StyledFlexColumn>
                  <Styles.StyledFieldLabel htmlFor="email">
                    <Trans>Email</Trans>
                  </Styles.StyledFieldLabel>
                  <Styles.StyledFieldInput
                    id="email"
                    className={this.state.invalidEmailClass}
                  >
                    <I18n>
                      {({ i18n }) => (
                        <TextInput
                          name="email"
                          onBlur={(email) =>
                            this.setState({ email }, function() {
                              this.emailValidator();
                            })
                          }
                          value={this.state.email}
                          placeholder=""
                          inputUIType="NORMAL"
                          disabled={this.state.inactivePage}
                        />
                      )}
                    </I18n>
                    <Styles.StyledErrorMessage>
                      <AlertExplanation
                        display={this.state.emailError ? 'inline' : 'none'}
                      />
                      <I18n>
                        {({ i18n }) => (
                          <span>
                            {this.state.emailError
                              ? i18n._(t`Invalid email address`)
                              : ''}
                          </span>
                        )}
                      </I18n>
                    </Styles.StyledErrorMessage>
                  </Styles.StyledFieldInput>
                </Styles.StyledFlexColumn>
                <Styles.StyledFlexColumn>
                  <Styles.StyledFieldLabel htmlFor="phone">
                    <Trans>Phone number</Trans>
                  </Styles.StyledFieldLabel>
                  <Styles.StyledPhoneInput
                    id="phone"
                    className={this.state.invalidPhoneClass}
                  >
                    <I18n>
                      {({ i18n }) => (
                        <ReactPhoneInput
                          inputStyle={{}}
                          disableDropdown="true"
                          name="phone"
                          placeholder=""
                          type="tel"
                          onChange={(phone) => this.setState({ phone })}
                          onBlur={() => this.phoneValidator()}
                          value={this.state.phone}
                          disabled={this.state.inactivePage}
                        />
                      )}
                    </I18n>
                    <Styles.StyledErrorMessage style={{ marginTop: '4px' }}>
                      <AlertExplanation
                        display={this.state.phoneError ? 'inline' : 'none'}
                      />
                      <I18n>
                        {({ i18n }) => (
                          <span>
                            {this.state.phoneError
                              ? i18n._(t`Invalid phone number`)
                              : ''}
                          </span>
                        )}
                      </I18n>
                    </Styles.StyledErrorMessage>
                  </Styles.StyledPhoneInput>
                </Styles.StyledFlexColumn>
              </Styles.StyledFlexRow>
              <Styles.StyledFlexRow
                className={this.state.inactivePage ? 'inactive-page' : ''}
              >
                <Styles.StyledFlexColumn>
                  <Styles.StyledFieldLabel htmlFor="issue">
                    <Trans>Tell us about your issue</Trans>
                  </Styles.StyledFieldLabel>
                  <Styles.StyledInputMessage>
                    <I18n>
                      {({ i18n }) => (
                        <TextArea
                          name="issue"
                          label={null}
                          placeholder={i18n._(
                            t`Enter your question, providing as much context as you can.`
                          )}
                          value={this.state.issue}
                          onChange={this.onChange}
                          required=""
                          disabled={this.state.inactivePage}
                        />
                      )}
                    </I18n>
                    <Styles.StyledCounterText>
                      {this.state.textAreaCount}/512
                    </Styles.StyledCounterText>
                  </Styles.StyledInputMessage>
                </Styles.StyledFlexColumn>
              </Styles.StyledFlexRow>
            </Styles.StyledForm>
            <Styles.StyledLine color="#cccccc" />
            <Styles.StyledFormSubmission>
              <Styles.StyledFlexRow>
                <Styles.StyledFlexColumn>
                  <div className="button-spinner" style={{ display: 'none' }} />
                  <Styles.StyledPrimaryCtaButton>
                    <I18n>
                      {({ i18n }) => (
                        <Button
                          size="large"
                          title={i18n._(t`VERIFY DETAILS`)}
                          onClick={() => this.onSubmit()}
                          data-wat-val="verify user info form"
                          disabled={
                            this.state.inactivePage
                              ? true
                              : this.state.buttonDisabled
                          }
                        />
                      )}
                    </I18n>
                  </Styles.StyledPrimaryCtaButton>
                </Styles.StyledFlexColumn>
                <Styles.StyledFlexColumn>
                  <Styles.StyledSecondaryCtaButton>
                    <I18n>
                      {({ i18n }) => (
                        <Button
                          size="large"
                          title={i18n._(t`CANCEL`)}
                          data-wat-val="cancel user info form"
                          onClick={() => this.state.closeModal()}
                          type="secondary"
                        />
                      )}
                    </I18n>
                  </Styles.StyledSecondaryCtaButton>
                </Styles.StyledFlexColumn>
              </Styles.StyledFlexRow>
            </Styles.StyledFormSubmission>
          </form>
        </Styles.StyledWrapper>
      </ErrorBoundary>
    );
  }
}

// UserInfoForm.propTypes = {
//   firstName: PropTypes.string,
//   lastName: PropTypes.string,
//   email: PropTypes.string,
// };

// UserInfoForm.defaultProps = {
//   firstName: '',
//   lastName: '',
//   email: '',
// }

export default UserInfoForm;
